// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__aiCOx","title":"InfoRow_title__1Pkgo"};